import { Button, ButtonSize, ButtonWidth } from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import React, { type FC } from 'react';

import { type CoachCategoriesCategoryInformationFragment } from './__generated-gql-types__/CoachCategories.generated';

interface CoachCategoriesProps {
  coachSlug: string;
  coachFirstName: string;
  categoryInformationList: CoachCategoriesCategoryInformationFragment[];
}

export const CoachCategories: FC<CoachCategoriesProps> = ({
  coachSlug,
  coachFirstName,
  categoryInformationList,
}) => {
  return (
    <div>
      <div className="text-5.5 font-medium leading-7">
        <h2 className="text-leland-gray-extra-light">
          Interested in coaching?
        </h2>
        <h2 className="text-leland-gray-dark">
          Select a category below to view {coachFirstName}&rsquo;s offerings.
        </h2>
      </div>
      <div className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {categoryInformationList
          .filter(({ isHidden }) => !isHidden)
          .map(({ category }) => (
            <Link
              key={category.id}
              href={`/coach/${coachSlug}/${category.slug}`}
              id="coach_profile:select_category"
            >
              <Button
                label={category.name}
                size={ButtonSize.LARGE}
                width={ButtonWidth.FULL}
              />
            </Link>
          ))}
      </div>
    </div>
  );
};
